import styled from 'styled-components';
import inputStyles from '../Styles/inputStyles';

export const Textarea = styled.textarea`
  ${inputStyles}
  padding: 10px 18px;
  min-height: 200px;
  resize: none;
`;
export default Textarea;
